import { Application } from "@hotwired/stimulus"

import SidebarController from "./sidebar_controller"
import AutoDismissController from "./auto_dismiss_controller"
import TiptapController from "./tiptap_controller"
import HighlightController from "./highlight_controller"
import ModalController from "./modal_controller"
import ComposerController from "./composer_controller"
import AmbientController from "./ambient_controller"
import RecaptchaController from "./recaptcha_controller"
import PostSettingsController from "./post_settings_controller"
import SortableController from "./sortable_controller"

const application = Application.start()
application.debug = false
window.Stimulus = application

application.register("sidebar", SidebarController)
application.register("auto-dismiss", AutoDismissController)
application.register("tiptap", TiptapController)
application.register("highlight", HighlightController)
application.register("modal", ModalController)
application.register("composer", ComposerController)
application.register("ambient", AmbientController)
application.register("recaptcha", RecaptchaController)
application.register("post-settings", PostSettingsController)
application.register("sortable", SortableController)

export { application }
